<template>
  <div>
    <b-modal
      :model-value="showDialogEdit"
      hide-footer
      hide-header-close
      centered
      :title="labels.information"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog"
    >
      <div class="uniform-modal-body">
        <div class="password-policy-box mb-3">
          <div class="password-policy-title">{{ labels.infoTitle }}</div>
          <div class="password-policy-item">{{ labels.infoText }}</div>
        </div>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5>{{labels.name}}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input v-model="form.nombre" type="text" class="reset-input"></b-form-input>
          </b-col>
        </b-row>

        <b-row class="d-flex align-items-center uniform-form-row">
          <b-col cols="12" md="4" class="text-left uniform-label-col">
            <h5>{{labels.description}}</h5>
          </b-col>
          <b-col cols="12" md="8" class="text-left">
            <b-form-textarea v-model="form.descripcion" rows="3" max-rows="6" class="reset-input"></b-form-textarea>
          </b-col>
        </b-row>

        <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
          <b-button class="mr-2 reset-btn-secondary" @click="closeModal()">{{ labels.cerrar }}</b-button>
          <b-button class="reset-btn-primary" @click="editInfoRol(form)">{{ labels.guardar }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Rol from "@/services/Roles";
export default {
    props:['showDialogEdit','Item'],
    data(){
        return{
            isLoading:false,
            form:{
              id: null,
              nombre: '',
              descripcion: ''
            },
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                  information: "Editar Rol",
                  name: "Nombre:",
                  description: "Descripción:",
                  guardar : "Guardar",
                  cerrar : "Cerrar",
                  infoTitle: "Datos del rol",
                  infoText: "Actualiza la información y guarda los cambios."
                }
            }else {
                return {
                  information: "Edit Rol",
                  name: "Name:",
                  description: "Description:",
                  guardar : "Save",
                  cerrar : "Close",
                  infoTitle: "Role information",
                  infoText: "Update the information and save changes."
                }
            }
        }
    },
    watch:{
      Item:{
        immediate:true,
        handler(newValue){
          const currentItem = newValue || {};
          this.form = {
            id: currentItem.id || null,
            nombre: currentItem.nombre || '',
            descripcion: currentItem.descripcion || ''
          };
        }
      }
    },
    methods:{
      editInfoRol(Item){
        // console.log(Item) 
        // this.isLoading = true; 
        Item.idUser = this.$store.state.userId 
        Rol.updateRolById(Item) 
        .then(() => { 
          this.isLoading = true; 
          // this.roles = rta.data.roles; 
          this.$toast.success("Rol editado correctamente") 
          location. reload() 
        })
        .catch((error) => { 
          console.log(error); 
          this.error = true; 
        })
        .finally(() => { 
          this.isLoading = false; 
        });
      },
      closeModal(){
        this.$emit('closeModal',false) 
      }
    }
}
</script>
